module.exports = __webpack_public_path__ + "img/nontraditional.20289fe0.svg";